import { API_URL } from "env";

export interface ProductManufacturerItem {
    id: number;
    name: string;
    is_active: number;
    position: number;
    slug: string;
    avatar: string;
    seo_page: string;
    created_at: string;
}

async function getProductManufacturerList(): Promise<ProductManufacturerItem[]> {
    try {
        const response = await fetch(`${API_URL}/api/v1/fe/manufacturers?limit=100`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        if (!data.status) {
            throw new Error('Failed to fetch product manufacturers');
        }
        return data.data.items || [];
    } catch (error) {
        console.error("Error fetching product manufacturers:", error);
        throw error;
    }
}

export {
    getProductManufacturerList,
}